require('../../../../../../resources/js/bootstrap');
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Room, RoomEvent, Track } from 'livekit-client';
import QuestionLiveKitModal from './react/QuestionLiveKitModal';

'use strict';

let livekit_instances = [];
let livekit_room;
let dailyco_bank;
let wait_room_audio;
let current_user;
let current_operator;
let current_settings;
let livekit_connected = false;
const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();

/**
 * Array of all rooms with user data, LiveKit data and settings data
 * @type {*[]}
 */
let roomList = [];

let module_id;
let reactLiveKitRoot = null;

function useReactUI () {
  return true;
}

function mountReactLiveKit (token) {
  const mountNode = document.querySelector(`#module-instance-id-${module_id}_lk_root`);
  if (!mountNode) return;

  if (!reactLiveKitRoot) reactLiveKitRoot = createRoot(mountNode);
  reactLiveKitRoot.render(
    React.createElement(QuestionLiveKitModal, {
      token,
      serverUrl: current_settings.domain,
      onLeave: () => handleLeave(),
    })
  );
}

function unmountReactLiveKit () {
  reactLiveKitRoot?.unmount();
  reactLiveKitRoot = null;
}

async function setupModule (remote_module_id, actualRoom) {
  module_id = remote_module_id;

  dailyco_bank =
    document.querySelector(`#module-instance-id-${module_id}_dailyco_bank`) ||
    document.querySelector(`#module-instance-id-${module_id}_lk_root`);

  const data = await (await fetch(`/room/${actualRoom}/module/${module_id}/api?action=metadata`)).json();
  current_settings = data.settings //enabled focus message

  //Set thankyou_message
  document.querySelector('#thankyou_message').innerHTML = current_settings.thankyou_message;

  //Set disabled module message
  document.querySelector('#disabled_message').innerHTML = current_settings.disabled_message;

  //Set disabled module instant message
  document.querySelector('#instant_disabled_message').innerHTML = current_settings.instant_disabled_message;
  [].forEach.call(data.user.groups, function (group) {
    if (group["id"] === data.group_everyone) return;
    Echo.private(`room.${actualRoom}.module.${module_id}.group.${group["id"]}.settings`)
      .listen('ModuleSettingsUpdate', async (event) => {
        if (event.settings.enabled == '0' && current_settings.enabled == '1') {
          disableModule();
        }
        else if (event.settings.enabled == '1' && current_settings.enabled == '0') {
          enableModule();
        }
        current_settings = event.settings
      });
  });
  // No instant question request
  if (current_settings.instant_question_request == '0') {
    document.querySelector('.askQuestion').removeEventListener('click', handleAskQuestion)
    document.querySelector('.askQuestion').addEventListener('click', handleAskQuestion);
  }
  // Module enabled and instant question request
  if (current_settings.enabled == '1' && current_settings.instant_question_request == '1') {
    setupClient();
  }
  else if (current_settings.enabled == '0' && current_settings.disabled_welcome_message_show == '1') {
    document.querySelector('.question_disabled_welcome_container').style.display = 'block';
  }
  if (current_settings.ask_again == '1') {
    document.querySelector('.askQuestionAgain').removeEventListener('click', handleAskQuestionAgain);
    document.querySelector('.askQuestionAgain').addEventListener('click', handleAskQuestionAgain);
  }
}


export async function setupClient () {
  if (useReactUI()) {
    requestRoom();
    return;
  }

  livekit_room = new Room({
    adaptiveStream: true,
    dynacast: true,
  });

  livekit_room
    //.on(RoomEvent.DataReceived, updateChat)
    .on(RoomEvent.Disconnected, showEvent)
    .on(RoomEvent.ParticipantConnected, participantJoined)
    .on(RoomEvent.ParticipantDisconnected, participantLeft)
    .on(RoomEvent.TrackSubscribed, trackStarted)
    .on(RoomEvent.TrackUnsubscribed, trackStopped)
    .on(RoomEvent.TrackPublished, trackPublished)
    .on(RoomEvent.TrackUnpublished, trackUnpublished);


    livekit_instances.push(
      {
          livekit_room: livekit_room,
          dailyco_bank: dailyco_bank,
          status: 'idle', // idle, live, preview
          layer: -1 // -1 idle/preview, 0=Layer 1, 1=Layer 2
      });

    requestRoom();
}

function livekitConnected () {
  if (livekit_connected) return;

  if (useReactUI()) {
    livekit_connected = true;
    return;
  }

  setupWaitRoomAudio();
  livekit_connected = true;

}


function handleLeave () {
  deleteRoom(current_user);
  leaveCall();
}

function handleSettings () {
  toggleDisplay('settings_container');
  
}

function handleSettingsClose () {
  closeDisplay('settings_container');
  
}


function handleToggleChat () {
  toggleChat()
}

function handleToggleAudio () {
  const enabled = livekit_room.localParticipant.isMicrophoneEnabled;
  livekit_room.localParticipant.setMicrophoneEnabled(!enabled);
  document.querySelector('#dailyco_button_toggle_audio').classList.toggle('mute');
}

function handleToggleVideo () {
  const enabled = livekit_room.localParticipant.isCameraEnabled;
  livekit_room.localParticipant.setCameraEnabled(!enabled);
  document.querySelector('#dailyco_button_toggle_video').classList.toggle('mute');
}

function handleAskQuestion () {
  setupClient();
  document.querySelector('.question_disabled_welcome_container').style.display = 'none';
  document.querySelector('.question_button_container').style.display = 'none';
  document.querySelector('.question_thankyou_container').style.display = 'none';
  document.querySelector('.question_container').style.display = 'block';
}

function handleAskQuestionAgain () {
  requestRoom();
  document.querySelector('.question_disabled_welcome_container').style.display = 'none';
  document.querySelector('.question_button_container').style.display = 'none';
  document.querySelector('.question_thankyou_container').style.display = 'none';
  document.querySelector('.question_container').style.display = 'block';
}

function handleSendChatMessage () {
  if (document.querySelector('#input_chat_message').value == '') return;
  outgoingChatMessage(document.querySelector('#input_chat_message').value);
  document.querySelector('#input_chat_message').value = '';
}

function handleSendChatMessageByKey (event) {
  if (event.keyCode != 13) return;
  event.preventDefault();
  handleSendChatMessage();
}

async function deleteRoom (room) {
  //Delete dailyco room and room in db
  const result = await (await fetch(`/room/${actualRoom}/module/${module_id}/api?action=deleteRoomByUser`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(room)
  }));
}

function setupWaitRoomAudio () {
  if (current_settings.audio_play == 1 && current_settings.mp3 != '' && current_settings.instant_question_request != 1) wait_room_audio = new Audio(`/room/${actualRoom}/module/${module_id}/public?action=mp3`);
  if (current_settings.audio_loop == 1) wait_room_audio.loop = true;
  wait_room_audio?.play();
}
/* Event listener callbacks */

async function requestRoom () {
  const response = (await fetch(`/room/${actualRoom}/module/${module_id}/api?action=request`));
  const json = await response?.json();

  if (json.room.settings.status == 1) setKickstartPreview();
  else if (json.room.settings.status == 2) setKickstartLive();

  current_user = json;


  //Setup Websocket Event
  Echo.private(`room.${actualRoom}.module.${module_id}.user.${current_user.user.id}.settingsChanged`)
    .listen('.Modules\\Question\\Events\\DailyCoRoomUserSettingsChanged', async (event) => {
      if (current_user.user.id === event.dailyCoRoom.user.id) {
        if ((current_user.room.settings.status == 1 || current_user.room.settings.status == 2) && event.dailyCoRoom.settings.status == 0) {
          //
        }

        current_user.room = event.dailyCoRoom;

        switch (current_user.room.settings.status) {
          // User waiting
          case 0:
            setBackgroundIdle();
            break;

          // User preview
          case 1:
            setBackgroundPreview();
            break;

          // User live
          case 2:
            setBackgroundLive();
            break;
        }
      }
    });

  Echo.private(`room.${actualRoom}.module.${module_id}.user.${current_user.user.id}.deleted`)
    .listen('.Modules\\Question\\Events\\DailyCoRoomUserDeleted', async (event) => {
      leaveCall();
    });

  joinCall(json.room.dailyCo.token);

}

// Joins LiveKit room
// Connects to the LiveKit server using the provided token



async function joinCall (token) {
  if (useReactUI()) {
    mountReactLiveKit(token);
    livekitConnected();
    return;
  }

  await livekit_room.connect(current_settings.domain, token);
  console.log('LiveKit connected to room:', livekit_room.name);

  // Enable local camera and microphone
  await livekit_room.localParticipant.setCameraEnabled(true);
  await livekit_room.localParticipant.setMicrophoneEnabled(true);

  // Run post-connection setup (previously in livekitConnected)
  livekitConnected();

  // Subscribe to tracks of already-present participants
  livekit_room.remoteParticipants.forEach((participant) => {
    const [rank, userID] = participant.identity.split('_');
    if (rank === 'operator') {
      setNewOperator(participant, userID);
    } else if (rank === 'player') {
      setNewPlayer(participant);
    }
  });
}

/* Event listener callbacks */

// Logs the LiveKit event to the console
function showEvent (e) {
  console.log('livekit_room event', e);
}

/**
* Displays the chat window on user click
* Changes style of 'Chat' text from red, after new message, to white once clicked
*/
async function toggleChat () {
  document.querySelector('.chat').classList.toggle('hidden');
  document.querySelector('#dailyco_button_toggle_chat').classList.toggle('mute');
  //document.querySelector('#dailyco_instance').height = document.querySelector('#dailyco_instance').contentWindow.document.body.scrollHeight + 'px';
}

/**
* Updates a participant's local chat window display when the send button is clicked
* Uses publishData() to broadcast the message the participant typed to all participants
*/
async function outgoingChatMessage (message) {
  // Local update
  pushMessageToChatHistory('outgoing', current_user.user, message);
  const data = textEncoder.encode(JSON.stringify({ message: message }));
  await livekit_room.localParticipant.publishData(data, { reliable: true });
}

/**
* Responds to a DataReceived event
* Parses the received data and displays the message in the chat
*/
async function updateChat (payload, participant) {
  const data = JSON.parse(textDecoder.decode(payload));
  pushMessageToChatHistory('incoming', current_operator, data.message);
}

async function leaveCall () {
  Echo.leaveChannel(`private-room.${actualRoom}.module.${module_id}.user.${current_user.id}.settingsChanged`);
  Echo.leaveChannel(`private-room.${actualRoom}.module.${module_id}.user.${current_user.id}.deleted`);
  unmountReactLiveKit();

  document.querySelector('.ui-controller')?.classList.remove('show');
  livekit_room?.disconnect();

  if (dailyco_bank) dailyco_bank.innerHTML = "";

  wait_room_audio?.pause();
  document.querySelector('.question_disabled_welcome_container').style.display = 'none';
  document.querySelector('.question_button_container').style.display = 'none';
  document.querySelector('.question_container').style.display = 'none';
  document.querySelector('.question_thankyou_container').style.display = 'block';
  document.querySelector('.question_disabled_container').style.display = 'none';
  setBackgroundIdle();
}

async function participantJoined (participant) {
  const [rank, userID] = participant.identity.split('_');
  if (rank === 'operator') {
    setNewOperator(participant, userID);
  } else if (rank == 'player') {
    setNewPlayer(participant);
  }
}

async function setNewPlayer (participant) {
  participant.trackPublications.forEach((publication) => {
    if (publication.source === Track.Source.ScreenShare || publication.source === Track.Source.ScreenShareAudio) {
      publication.setSubscribed(false);
    } else {
      publication.setSubscribed(true);
    }
  });
}

async function setNewOperator (participant, userID) {
  const users = await (await fetch(`/api/user/${userID}`)).json();
  current_operator = users[userID];
  wait_room_audio?.pause();
  //document.querySelector('.question_container .loading_animation').style.display = 'none';
  participant.trackPublications.forEach((publication) => {
    if (publication.source === Track.Source.ScreenShare || publication.source === Track.Source.ScreenShareAudio) {
      publication.setSubscribed(false);
    } else {
      publication.setSubscribed(true);
    }
  });

}

async function participantLeft (participant) {
  const [rank, userID] = participant.identity.split('_');
  if (rank === 'local' || rank === 'player') return;

}

/**
* Subscribe to new tracks published by operators and players
*/
function trackPublished (publication, participant) {
  const [rank] = participant.identity.split('_');
  if (rank === 'operator' || rank === 'player') {
    if (publication.source !== Track.Source.ScreenShare && publication.source !== Track.Source.ScreenShareAudio) {
      publication.setSubscribed(true);
    }
  }
}

function setKickstartLive () {
  setBackgroundLive();
  document.querySelector('.question_button_container').style.display = 'none';
  document.querySelector('.question_container').style.display = 'block';
}

function setKickstartPreview () {
  setBackgroundPreview();
  document.querySelector('.question_button_container').style.display = 'none';
  document.querySelector('.question_container').style.display = 'block';
}

function pushMessageToChatHistory (type, user, message) {
  var currentdate = new Date();
  var currenttime = currentdate.getHours() + ':' + currentdate.getMinutes() + ':' + currentdate.getSeconds();

  // Tabelle mit dem existierenden HTML tbody und der Zeile (row) aus dem template Element instantiieren
  var chat_message_template = document.querySelector('#chat_message');
  let float_position_class = ''

  if (type == 'incoming') float_position_class = 'left';
  else if (type == 'outgoing') float_position_class = 'right';

  var chat_message_template = document.querySelector('#chat_message').content.cloneNode(true);
  chat_message_template.querySelector('li').classList.add(float_position_class);
  //chat_message_template.querySelector('.chat-img img').src = user.role=='bot'?'/img/avatars/'+user.avatar_image:'/image/user/'+user.id;
  chat_message_template.querySelector('.username').textContent = user.forename + ' ' + user.surname;
  chat_message_template.querySelector('.timestamp').textContent = currenttime;
  chat_message_template.querySelector('.message').textContent = message;

  var chat_history = document.querySelector('#chat_history');
  chat_history.appendChild(chat_message_template);

  document.querySelector('.chat .panel-body').scrollTop = document.querySelector('.chat .panel-body').scrollHeight;
}



function enableModule () {
  document.querySelector('.askQuestion').removeEventListener('click', handleAskQuestion)
  document.querySelector('.askQuestion').addEventListener('click', handleAskQuestion);
  document.querySelector('.question_disabled_welcome_container').style.display = 'none';
  document.querySelector('.question_button_container').style.display = 'block';
  document.querySelector('.question_container').style.display = 'none';
  document.querySelector('.question_thankyou_container').style.display = 'none';
  document.querySelector('.question_disabled_container').style.display = 'none';
}

function disableModule () {
  if (current_user != null) {
    Echo.leaveChannel(`private-room.${actualRoom}.module.${module_id}.user.${current_user.user.id}.settingsChanged`);
    Echo.leaveChannel(`private-room.${actualRoom}.module.${module_id}.user.${current_user.user.id}.deleted`);
  }
  unmountReactLiveKit();
  livekit_room?.disconnect();
  wait_room_audio?.pause();
  document.querySelector('.question_disabled_welcome_container').style.display = 'none';
  document.querySelector('.question_button_container').style.display = 'none';
  document.querySelector('.question_container').style.display = 'none';
  document.querySelector('.question_thankyou_container').style.display = 'none';
  document.querySelector('.question_disabled_container').style.display = 'block';
 // document.querySelector('#chat_history').innerHTML = '';
  if (dailyco_bank) dailyco_bank.innerHTML = "";
  setBackgroundIdle();
}

function setBackgroundLive () {
  if (current_settings.show_tally_colors != '1') return;
  if (document.querySelector('.question_container.preview') != null) document.querySelector('.question_container.preview').classList.remove('preview');
  if (document.querySelector('.question_container.live') == null) document.querySelector('.question_container').classList.add('live');
}

function setBackgroundPreview () {
  try {
    //var videoTags = document.getElementById("iframe_livestream").contentWindow.document.getElementsByTagName('video')
    //for (var i = 0; i < videoTags.length; i++) {
    //videoTags.item(i).muted = true;
    //}
    player.mute();
  } catch (e) {
    console.log(e);
  }
  console.log("_____preview");
  if (document.querySelector('#qa_container') != null) document.querySelector('#qa_container').classList.add('show');
  if (current_settings.show_tally_colors != '1') return;
  if (document.querySelector('.question_container.live') != null) document.querySelector('.question_container.live').classList.remove('live');
  if (document.querySelector('.question_container.preview') == null) document.querySelector('.question_container').classList.add('preview');
}

function setBackgroundIdle () {
  try {
    //var videoTags = document.getElementById("iframe_livestream").contentWindow.document.getElementsByTagName('video')
    /*for (var i = 0; i < videoTags.length; i++) {
      videoTags.item(i).muted = false;
    } */
    player.unmute();
  } catch (e) {
    console.log(e);
  }
  document.querySelector('.wait_message').style.display = 'block';
  if (document.querySelector('#qa_container') != null) document.querySelector('#qa_container').classList.remove('show');
  if (document.querySelector('.question_container.live') != null) document.querySelector('.question_container.live').classList.remove('live');
  if (document.querySelector('.question_container.preview') != null) document.querySelector('.question_container.preview').classList.remove('preview');
}

function trackStarted (track, publication, participant) {
  // Skip local audio to prevent echo
  if (track.kind === Track.Kind.Audio && participant.isLocal) return;
  // Skip screen share
  if (publication.source === Track.Source.ScreenShare || publication.source === Track.Source.ScreenShareAudio) return;

  const element = track.attach();
  element.dataset.session_id = participant.sid;
  element.dataset.track_sid = publication.trackSid || track.sid;
  element.dataset.local = participant.isLocal;
  dailyco_bank.appendChild(element);
}

function trackStopped (track, publication, participant) {
  track.detach().forEach(element => element.remove());
}

function trackUnpublished (publication, participant) {

  console.log('Track unpublished:', publication.trackSid);


  // Also remove elements by track SID if available
  if (publication && publication.trackSid) {
    document.querySelectorAll('[data-track_sid="' + publication.trackSid + '"]').forEach(el => el.remove());
    console.log('Removed elements with track SID:', publication.trackSid);
  } else {
    console.warn('No track SID available for unpublished track');
  }
}



async function changeDevice () {
  for (let i = 0; i < livekit_instances.length; i++) {
      await livekit_instances[i].livekit_room.switchActiveDevice('audiooutput', document.getElementById('current_audio_output').value);
      await livekit_instances[i].livekit_room.switchActiveDevice('audioinput', document.getElementById('current_audio_input').value);
      await livekit_instances[i].livekit_room.switchActiveDevice('videoinput', document.getElementById('current_video_input').value);
  }
}

async function enumerateDevices () {
  livekit_instances[0]['audio_input_devices'] = [];
  livekit_instances[0]['audio_output_devices'] = [];
  livekit_instances[0]['video_input_devices'] = [];

  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    for (const device of devices) {
      switch (device.kind) {
        case 'videoinput':
          livekit_instances[0]['video_input_devices'].push(device);
          break;
        case 'audioinput':
          livekit_instances[0]['audio_input_devices'].push(device);
          break;
        case 'audiooutput':
          livekit_instances[0]['audio_output_devices'].push(device);
          break;
      }
    }
  } catch (err) {
    console.log(err.name + ': ' + err.message);
  }
}



function toggleDisplay (elementID) {
  (function (style) {
      style.display = style.display === 'none' ? 'block' : 'none';
      document.getElementById(elementID).classList.add('show');
  })(document.getElementById(elementID).style);
}

function closeDisplay (elementID) {
  (function (style) {
      style.display = style.display === 'none' ? 'block' : 'none';
      document.getElementById(elementID).classList.remove('show');
  })(document.getElementById(elementID).style);
}


export default async (module_id, actualRoom, settings) => {
  console.log('%c ❓ QuestionModule Loaded! ', 'background: #222; color: #bada55');
  setupModule(module_id, actualRoom);
  App.loadedModule(module_id, actualRoom);
}
